// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__So1SB","inner":"Page_inner__2ZM6W","upload-page":"Page_upload-page__15Rbw"};